"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const components_1 = require("../../components");
const __1 = require("../");
const react_1 = __importStar(require("react"));
const usePlacesAutocompleteService_1 = __importDefault(require("react-google-autocomplete/lib/usePlacesAutocompleteService"));
const GooglePlacesContext_1 = require("../../contexts/GooglePlacesContext");
const utils_1 = require("./utils");
const icons_1 = require("../../icons");
const GooglePlacesAutocompleteField = ({ label, name, type, onChange, validate, maxWidth = '450px', }) => {
    const { googlePlacesKey } = (0, GooglePlacesContext_1.useGooglePlacesContext)();
    const [isShowingPredictions, setIsShowingPredictions] = (0, react_1.useState)(false);
    const { placesService, placePredictions, getPlacePredictions } = (0, usePlacesAutocompleteService_1.default)({
        apiKey: googlePlacesKey,
        debounce: 500,
    });
    (0, react_1.useEffect)(() => {
        setIsShowingPredictions(!!placePredictions.length);
    }, [placePredictions]);
    const handleClick = (placeId, input) => {
        placesService?.getDetails({
            placeId,
            fields: ['address_components', 'name'],
        }, (placeDetails) => {
            const usablePlaceDetails = (0, utils_1.getUsableAddressComponentsFromPlaceDetails)(placeDetails);
            if (type === 'name') {
                input.onChange(usablePlaceDetails.name);
            }
            else if (type === 'address') {
                input.onChange(usablePlaceDetails.address_first);
            }
            onChange?.(usablePlaceDetails);
        });
        setIsShowingPredictions(false);
    };
    // Google places returns an array of substrings that match the user's input.
    // This function bolds any text that does NOT match one of the substrings.
    const formatMainText = (prediction) => {
        const { main_text, main_text_matched_substrings } = prediction.structured_formatting;
        if (!main_text_matched_substrings.length) {
            return (react_1.default.createElement(components_1.Typography, { fontSize: 14, overflow: "hidden", textOverflow: "ellipsis", maxWidth: maxWidth, whiteSpace: "nowrap" },
                react_1.default.createElement("strong", null, main_text)));
        }
        const text = [];
        let lastSubstringIndex = 0;
        for (let i = 0; i < main_text_matched_substrings.length; i++) {
            const { offset, length } = main_text_matched_substrings[i];
            if (offset > lastSubstringIndex) {
                text.push(react_1.default.createElement(react_1.default.Fragment, null,
                    main_text[lastSubstringIndex] === ' ' ? react_1.default.createElement(react_1.default.Fragment, null, "\u00A0") : null,
                    react_1.default.createElement("strong", null, main_text.slice(lastSubstringIndex, offset)),
                    main_text[offset - 1] === ' ' ? react_1.default.createElement(react_1.default.Fragment, null, "\u00A0") : null));
            }
            const substring = main_text.slice(offset, offset + length);
            text.push(react_1.default.createElement(react_1.default.Fragment, null, substring));
            lastSubstringIndex = offset + length;
            if (i === main_text_matched_substrings.length - 1 && lastSubstringIndex < main_text.length) {
                text.push(react_1.default.createElement(react_1.default.Fragment, null,
                    main_text[lastSubstringIndex] === ' ' ? react_1.default.createElement(react_1.default.Fragment, null, "\u00A0") : null,
                    react_1.default.createElement("strong", null, main_text.slice(lastSubstringIndex))));
            }
        }
        return (react_1.default.createElement(components_1.Box, { display: "flex", flexDirection: "row" },
            react_1.default.createElement(components_1.Typography, { fontSize: 14, overflow: "hidden", textOverflow: "ellipsis", maxWidth: maxWidth, whiteSpace: "nowrap" }, text)));
    };
    const anchor = (0, react_1.useRef)();
    return (react_1.default.createElement(__1.Field, { name: name || (type === 'address' ? 'address_first' : 'name'), validate: validate, render: ({ input, meta }) => (react_1.default.createElement(components_1.Box, { ref: anchor },
            react_1.default.createElement(components_1.TextField, { label: label, fullWidth: true, value: input.value, onBlur: () => setIsShowingPredictions(false), onChange: (e) => {
                    input.onChange(e.target.value);
                    getPlacePredictions({
                        input: e.target.value,
                        componentRestrictions: {
                            country: 'us',
                        },
                        types: type === 'name' ? ['hospital'] : undefined,
                    });
                }, error: meta.touched && !!meta.error, helperText: meta.touched && !!meta.error ? meta.error : undefined }),
            react_1.default.createElement(components_1.Popper, { open: isShowingPredictions, anchorEl: anchor.current, sx: { zIndex: 100 } },
                react_1.default.createElement(components_1.Card, { sx: {
                        paddingX: '16px',
                        paddingY: '8px',
                        cursor: 'pointer',
                        boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.02), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
                    } },
                    react_1.default.createElement(components_1.Box, { display: "flex", flexDirection: "column", gap: 1 },
                        placePredictions.map((prediction, i) => (react_1.default.createElement("div", { key: i, onMouseDown: () => handleClick(prediction.place_id, input) },
                            react_1.default.createElement(components_1.Box, { height: 56, display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" },
                                formatMainText(prediction),
                                react_1.default.createElement(components_1.Typography, { fontSize: 14, overflow: "hidden", textOverflow: "ellipsis", maxWidth: maxWidth, whiteSpace: "nowrap" }, prediction.structured_formatting.secondary_text))))),
                        react_1.default.createElement(components_1.Box, { display: "flex", justifyContent: "flex-end", gap: 1, alignItems: "center" },
                            react_1.default.createElement(components_1.Typography, { sx: { fontFamily: 'Roboto', fontSize: '12px' } }, "Powered by"),
                            react_1.default.createElement(icons_1.GoogleLogo, null))))))) }));
};
exports.default = GooglePlacesAutocompleteField;
